import { Col, TextInputField } from '@/components';
import {
  BaseTextSearchCriteriaLabelModifier,
  baseTextSearchCriteria,
} from '@/features/project/_models/filter-base-data';
import { PS_MAX_KEYWORD_SEARCH_LENGTH } from '@/features/project/review-sheet/utils/constants';
import {
  COL_MIN_WIDTH,
  type SharedSearchFormKeys,
  type SharedSearchFormType,
} from '@/features/search/_utils/projects-search';
import { isPS } from '@/utils';
import { type FC, useEffect, useMemo } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useProjectsSearchFormProviderState } from '../ProjectsSearchAccordionProvider';

export const KeywordColField: FC = () => {
  const { t } = useTranslation();
  const { type } = useProjectsSearchFormProviderState();
  const {
    control,
    formState: { errors },
    setValue,
  } = useFormContext<SharedSearchFormType>();

  const watchedValues =
    type !== 'analysis'
      ? useWatch({
          control,
          name: [
            'sheetType',
            'fundSheetType',
            'skipAdministrativeReformTeamEvaluation',
          ],
        })
      : undefined;

  const [sheetType, fundSheetType, skipAdministrativeReformTeamEvaluation] =
    watchedValues ?? [];
  const isRSAndAdministrativeReformTeamEvaluation =
    sheetType === 'RS' && skipAdministrativeReformTeamEvaluation === 'true';

  useEffect(() => {
    if (skipAdministrativeReformTeamEvaluation === 'true') {
      setValue('isSearchTargetProjectName', true);
    }
  }, [skipAdministrativeReformTeamEvaluation, setValue]);

  const searchTarget = useMemo(() => {
    const targets =
      sheetType === 'KS' && fundSheetType !== 'standard'
        ? ['name', 'overview']
        : isRSAndAdministrativeReformTeamEvaluation
          ? ['name']
          : baseTextSearchCriteria.options;

    return targets
      .map((value) => `「${BaseTextSearchCriteriaLabelModifier[value]}」`)
      .join('');
  }, [sheetType, fundSheetType, isRSAndAdministrativeReformTeamEvaluation]);

  const _prefixText = isRSAndAdministrativeReformTeamEvaluation
    ? ''
    : t('hint-search-keyword-prefix-text', {
        target: searchTarget,
      });

  const _environmentText = isPS()
    ? `${t('hint-search-keyword-prefix-public', {
        limit: PS_MAX_KEYWORD_SEARCH_LENGTH,
      })}\n`
    : isRSAndAdministrativeReformTeamEvaluation
      ? ''
      : '\n';

  return (
    <Col span={8} style={{ minWidth: COL_MIN_WIDTH.large }}>
      <TextInputField
        name={'q' satisfies SharedSearchFormKeys}
        label={t('search-keyword')}
        // hint={t('hint-search-keyword', {
        //   prefix: `${prefixText}${environmentText}`,
        // })}
        // additionalLabelComponent={
        //   <CheckboxField
        //     text={t('search-keyword-project-name')}
        //     name={'isSearchTargetProjectName' satisfies SharedSearchFormKeys}
        //     control={control}
        //     errors={errors}
        //     disabled={isRSAndAdministrativeReformTeamEvaluation}
        //     wrapperStyle={{
        //       marginBottom: 0,
        //       marginLeft: 4,
        //       height: '22px',
        //       // .ant-form-item-control-inputのmin-heightを上書きするのが難しいので無理やり位置調整してます。
        //       transform: 'translateY(-4px)',
        //     }}
        //   />
        // }
        control={control}
        errors={errors}
        {...(isPS() && { maxLength: PS_MAX_KEYWORD_SEARCH_LENGTH })}
        allowClear
      />
    </Col>
  );
};
